export const SET_ADMIN_USERS_REQUEST = 'SET_ADMIN_USERS_REQUEST';
export const SET_ADMIN_USERS_SUCCESS = 'SET_ADMIN_USERS_SUCCESS';
export const SET_ADMIN_USERS_FAILED = 'SET_ADMIN_USERS_FAILED';
export const SET_ADMIN_USERS_DELETE_REQUEST = 'SET_ADMIN_USERS_DELETE_REQUEST';
export const SET_ADMIN_USERS_DELETE_SUCCESS = 'SET_ADMIN_USERS_DELETE_SUCCESS';
export const SET_ADMIN_USERS_DELETE_FAILED = 'SET_ADMIN_USERS_DELETE_FAILED';
export const CLEAN_ADMIN_USERS = 'CLEAN_ADMIN_USERS';
